import { createSelector } from "@reduxjs/toolkit";

const getUserState = (state) => state.userState;

const getIsLogin = (state) => state.isLogin;

const getIsRegister = (state) => state.isRegister;

const getPartnerIsWaiting = (state) => state.partnerIsWaiting;

const getPartnerIsRejected = (state) => state.partnerIsRejected;

const getIsForgotPassword = (state) => state.isForgotPassword;

const getErrorMessage = (state) => state.errorMessage;

const getIsResetPassword = (state) => state.isResetPassword;

export const authSelector = createSelector(
  [
    getUserState,
    getIsLogin,
    getIsRegister,
    getPartnerIsWaiting,
    getPartnerIsRejected,
    getIsForgotPassword,
    getErrorMessage,
    getIsResetPassword,
  ],
  (
    userState,
    isLogin,
    isRegister,
    partnerIsWaiting,
    partnerIsRejected,
    isForgotPassword,
    errorMessage,
    isResetPassword
  ) => ({
    userState,
    isLogin,
    isRegister,
    partnerIsWaiting,
    partnerIsRejected,
    isForgotPassword,
    errorMessage,
    isResetPassword,
  })
);
